export function addCurrent(group) {
    return {
        type: 'ADD_CURRENT',
        group,
    }
}
